import { render } from "./Singapore-view.vue?vue&type=template&id=6af55c85"
import script from "./Singapore-view.vue?vue&type=script&lang=js"
export * from "./Singapore-view.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__